module.exports = __webpack_public_path__ + "img/logo.5b583d72.png";